module.exports = __webpack_public_path__ + "img/download_code.d3cd912b.png";